import { useAtom, useAtomValue } from "jotai";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";

import type { BlurbCardHighlightSection } from "scmp-app/components/plus/atoms";
import { plusPopupAtom } from "scmp-app/components/plus/atoms";
import { QueryParameterName } from "scmp-app/components/plus/detailed-listing-popup/navigation";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import { pathname as homepagePathname } from "scmp-app/pages/plus";

export const usePlusBlurbPopup = () => {
  const [_, setPlusPopupState] = useAtom(plusPopupAtom);
  const pathname = usePathname();
  const searchParameters = useSearchParams();
  const handleOpen = useCallback(
    (section: BlurbCardHighlightSection) => {
      setPlusPopupState(current => ({
        ...current,
        currentBlurbCardHighlightSection: section,
        isShowBlurbPopup: true,
      }));
    },
    [setPlusPopupState],
  );

  const handleClose = useCallback(() => {
    setPlusPopupState(current => ({
      ...current,
      isShowBlurbPopup: false,
    }));
  }, [setPlusPopupState]);

  const checkPlusHomepagePathOnly = useMemo(
    () => pathname === homepagePathname && !searchParameters.get(QueryParameterName),
    [pathname, searchParameters],
  );

  const asyncRosettaState = useAtomValue(rosettaAtom);
  const hasScmpPlusAccessRight = asyncRosettaState?.result?.hasScmpPlusAccessRight ?? false;
  const hasScmpPlusUpgradeOptions =
    asyncRosettaState?.result?.user?.hasScmpPlusUpgradeOptions ?? false;
  const isEligibleForSCMPPlusFreeTrialSubscribeOffer =
    asyncRosettaState?.result?.user?.isEligibleForSCMPPlusFreeTrialSubscribeOffer ?? false;

  return {
    checkPlusHomepagePathOnly,
    handleClose,
    handleOpen,
    hasScmpPlusAccessRight,
    hasScmpPlusUpgradeOptions,
    isEligibleForSCMPPlusFreeTrialSubscribeOffer,
  };
};
